import React from "react"
import { Heading, VStack, Text, ListItem, List } from "@chakra-ui/react"

export default function OpenTimes({ data }) {
  return (
    <VStack align={{ base: "center", lg: "start" }} spacing={6}>
      <Heading as="h3" size="2xl">
        Opening times
      </Heading>
      <List>
        {Object.values(data).map((info, index) => {
          return (
            <ListItem textAlign={{ base: "center", lg: "start" }} key={index}>
              {info}
            </ListItem>
          )
        })}
      </List>
      <Text
        textAlign={{ base: "center", lg: "start" }}
        color="gray.200"
        size="xs"
      >
        Subject to change and may not be applicable during holiday periods or
        special events
      </Text>
    </VStack>
  )
}
